import React, { useEffect, useState, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import AssignmentIcon from "@material-ui/icons/Assignment";
import {
  Badge,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";
import moment from "moment";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles(() => ({
  mainPaper: {
    flex: 1,
    maxHeight: 380,
    minWidth: 320,
    maxWidth: 420,
    overflowY: "scroll",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
  },
  footer: {
    padding: "6px 8px",
    textAlign: "center",
  },
}));

// "Minhas Tarefas" - atalho rapido no topo (pedido do usuario
// 2026-08-28). Deliberadamente SIMPLES: so' mostra as pendentes, sem
// filtro de periodo/concluidas aqui dentro - isso agora mora na pagina
// dedicada "/tasks" (pages/Tasks), criada 2026-08-29 a pedido do
// usuario ("acho que vc deveria criar uma nova pagina para
// trabalharmos com as tarefas") depois que tentar caber filtro +
// edicao + nota num popover pequeno ficou confuso e bugado. Este
// componente e' so' o sininho de aviso; "Ver todas" leva pra pagina
// real.
export default function MyTasksPopover() {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [tasks, setTasks] = useState([]);

  const fetchTasks = useCallback(async () => {
    try {
      const { data } = await api.get("/my-tasks");
      setTasks(data || []);
    } catch (err) {
      // silencioso: não bloqueia o restante do app
    }
  }, []);

  useEffect(() => {
    if (user?.id) fetchTasks();
  }, [user?.id, fetchTasks]);

  useEffect(() => {
    // Fix 2026-10-22: socket pode ainda estar null no instante em que
    // user.companyId ja chegou (useAuth seta o user antes do socket
    // conectar) - F5 na tela com mais componentes concorrendo por CPU
    // (ex: Dashboard Novo) perde essa corrida com mais frequencia e
    // gerava "Cannot read properties of null (reading 'on')", tela
    // branca sem nenhum fallback. O efeito ja re-executa quando socket
    // deixa de ser null (esta em [user, socket, fetchTasks]).
    if (!user?.companyId || !socket) return undefined;
    const companyId = user.companyId;
    const onCardEvent = (data) => {
      if (["task-added", "task-updated", "task-removed"].includes(data.action)) {
        fetchTasks();
      }
    };
    socket.on(`company-${companyId}-card`, onCardEvent);
    return () => {
      socket.off(`company-${companyId}-card`, onCardEvent);
    };
  }, [user, socket, fetchTasks]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const goToCard = (task) => {
    const card = task.card;
    if (card?.boardId && card?.id) {
      history.push(`/boards?board=${card.boardId}&card=${card.id}`);
    }
    handleClose();
  };

  const goToTasksPage = () => {
    history.push("/tasks");
    handleClose();
  };

  if (!user?.id) return null;

  const open = Boolean(anchorEl);
  const visibleTasks = tasks.slice(0, 8);

  return (
    <div>
      <IconButton aria-describedby="my-tasks-popover" onClick={handleClick} style={{ color: theme.palette.primary.main }}>
        <Badge color="error" badgeContent={tasks.length} max={99}>
          <AssignmentIcon />
        </Badge>
      </IconButton>
      <Popover
        id="my-tasks-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Paper variant="outlined" className={classes.mainPaper}>
          <div className={classes.header}>
            <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
              Minhas Tarefas
            </Typography>
          </div>
          <Divider />
          <List component="nav" style={{ minWidth: 300 }}>
            {visibleTasks.length === 0 && (
              <ListItemText
                primary="Nenhuma tarefa pendente."
                style={{ padding: "12px 16px" }}
              />
            )}
            {visibleTasks.map((task) => {
              const overdue = task.dueDate && moment(task.dueDate).isBefore(moment());
              return (
                <ListItem
                  key={task.id}
                  button
                  onClick={() => goToCard(task)}
                  style={overdue ? { borderLeft: "4px solid #c62828", marginBottom: 4 } : { borderLeft: "4px solid transparent", marginBottom: 4 }}
                >
                  <ListItemText
                    primary={task.title}
                    secondary={
                      <>
                        {task.card?.title || task.card?.board?.name || "Card"}
                        {task.card?.phase?.name ? ` · ${task.card.phase.name}` : ""}
                        {task.dueDate && (
                          <>
                            {" · "}
                            <span style={overdue ? { color: "#c62828", fontWeight: "bold" } : undefined}>
                              {overdue ? "Atrasada: " : ""}
                              {moment(task.dueDate).format("DD/MM HH:mm")}
                            </span>
                          </>
                        )}
                      </>
                    }
                  />
                </ListItem>
              );
            })}
          </List>
          <Divider />
          <div className={classes.footer}>
            <Button size="small" color="primary" onClick={goToTasksPage}>
              Ver todas as tarefas
            </Button>
          </div>
        </Paper>
      </Popover>
    </div>
  );
}
